import { TableMap } from 'prosemirror-tables';
import { findParentNodeClosestToPos } from 'prosemirror-utils';
let largeClasses = {
  1: 'large-12',
  2: 'large-6',
  3: 'large-4',
  4: 'large-3'
};
let smallClasses = {
  1: 'small-12',
  2: 'small-12',
  3: 'small-12',
  4: 'small-6'
};
export function moveCursorToCell(composer, rowIndex, colIndex) {
  let tableNodeAndPos = composer.state.currentlyActiveTable;
  if (!tableNodeAndPos) {
    return;
  }
  let tableNode = tableNodeAndPos.node;
  let tableStartingPosition = tableNodeAndPos.start;
  let cellStartingPosition = TableMap.get(tableNode).positionAt(rowIndex, colIndex, tableNode);
  let newCursorPosition = tableStartingPosition + cellStartingPosition;
  composer.commands.setSelection(newCursorPosition, newCursorPosition);
}
export function getColumnCount(currentlyActiveTable) {
  if (!currentlyActiveTable) {
    return;
  }
  let tableNode = currentlyActiveTable;
  let tableMap = TableMap.get(tableNode);
  return tableMap.width;
}
export function getResponsiveClasses(colCount) {
  if (!colCount || colCount > 4) {
    return '';
  }
  return `${largeClasses[colCount] ?? ''} ${smallClasses[colCount] ?? ''} columns`;
}
export function nodeIsInLayoutOrSection(resolvedPosition, editorState) {
  let nodePredicate = node => {
    return node.type === editorState.schema.nodes.table && (node.attrs.container || node.attrs.responsive);
  };
  let parentNode = findParentNodeClosestToPos(resolvedPosition, nodePredicate);
  if (parentNode) {
    return true;
  }
  return false;
}